import "./Mission.css";

export default function Mission() {
  return (
    <div className="mission-container">

      <h1>Our Mission</h1>

      <p className="mission-text">
        Humara mission hai Paschimanchal ke youth ko ek strong platform dena,
        jahan se wo apni awaz utha sake aur apne region ke development me yogdan de sake.
      </p>

      <div className="mission-cards">

        <div className="card">
          <h3>Youth Empowerment</h3>
          <p>Youth ko opportunities aur direction dena</p>
        </div>

        <div className="card">
          <h3>Employment</h3>
          <p>Rozgar aur growth ke liye network create karna</p>
        </div>

        <div className="card">
          <h3>Education</h3>
          <p>Awareness aur learning ko promote karna</p>
        </div>

        <div className="card">
          <h3>Health & Environment</h3>
          <p>Health issues aur environment protection par focus</p>
        </div>

        <div className="card">
          <h3>Unity</h3>
          <p>Sabko ek platform par jodna</p>
        </div>

      </div>

    </div>
  );
}